export type DashboardBucket = '미지정' | '부분 입금' | '입금 완료' | '출고 완료' | '킵';

// 요약판 과거 조회일수 옵션 — 서버 RPC가 30~90으로 클램프하므로 이 범위 내 값만 사용
export type DashboardSummaryDays = 30 | 60 | 90;
export const DASHBOARD_SUMMARY_DAYS_OPTIONS: readonly DashboardSummaryDays[] = [30, 60, 90];
// 디폴트 30일 — 오너 지시(2026-07-08). 90일 전체는 토글로 선택(localStorage 기억).
export const DASHBOARD_SUMMARY_DAYS_DEFAULT: DashboardSummaryDays = 30;

// 렌더 순서 고정 상수 — JSONB 키 순서에 의존 금지 (스펙 §2)
export const DASHBOARD_BUCKETS: readonly DashboardBucket[] = ['미지정', '부분 입금', '입금 완료', '출고 완료', '킵'];

export interface DashboardSummaryOrder {
  id: number;
  nickname: string;
  order_date: string;
}

export interface DashboardSummaryBucket {
  count: number;
  orders: DashboardSummaryOrder[];
}

export interface DashboardKeepItem {
  name: string;
  totalQuantity: number;
  nicknames: Record<string, number>;
}

export interface DashboardSummary {
  statuses: Record<DashboardBucket, DashboardSummaryBucket>;
  keepItems: DashboardKeepItem[];
}

// ─── 고객별 월 구매 총액 (get_customer_monthly_totals_rpc) ───

export interface CustomerMonthlyTotalRow {
  nickname: string;
  order_count: number;
  total_amount: number;
}

export interface CustomerMonthlyTotals {
  /** 서버가 실제 조회한 월 ('YYYY-MM-DD', 1일 고정). 요청이 범위 밖이면 클램프된 월이 돌아온다. */
  month: string;
  /** 금액 내림차순, 동액은 닉네임 오름차순. 서버에서 cap개로 잘린다. */
  customers: CustomerMonthlyTotalRow[];
  /** 캡 이전 전량 기준 고객 수 — 요약 줄이 잘린 값을 보여주지 않게 하기 위함 */
  customer_count: number;
  /** 캡 이전 전량 기준 합계 금액 */
  total_amount: number;
  /** 서버가 적용한 상한. "상위 N명만 표시" 카피가 서버와 갈라지지 않도록 응답으로 받는다. */
  cap: number;
  /** customer_count가 cap을 넘었는지 */
  is_partial: boolean;
}
